module.exports = __webpack_public_path__ + "img/registre_transport.7a3852ad.png";